import React, { Component, Fragment } from 'react';
import { Form, Text } from 'informed';

import { ContentWrapper, HeadingWrapper } from '../Shared/Structural';
import { IconSearch } from '../Shared/IconSearch';
import { AdvancedSearchForm } from '../AdvancedSearchForm/AdvancedSearchForm';

import { PrimarySearchFormStyles } from './styled-components';

export class PrimarySearchForm extends Component {
  constructor(props) {
    super(props);

    this.state = {
      showAdvancedForm: false
    };

    this.toggleAdvancedFormDialog = this.toggleAdvancedFormDialog.bind(this);
  }

  toggleAdvancedFormDialog() {
    if (!this.state.showAdvancedForm) {
      // Clear simple input when showing advanced search
      document.querySelector('.search-form__input').value = '';
    }
    this.setState({
      showAdvancedForm: !this.state.showAdvancedForm
    });
  }

  componentDidMount() {
    const input = document.querySelector('.search-form__input');
    const label = document.querySelector('.search-form__label');
    input.addEventListener('focus', () => {
      label.classList.add('active');
    });

    input.addEventListener('blur', () => {
      label.classList.remove('active');
    });
  }

  render() {
    const { toggleAdvancedFormDialog } = this;
    const { showAdvancedForm } = this.state;
    const { onSubmit } = this.props;

    return (
      <Fragment>
        <ContentWrapper>
          <HeadingWrapper>
            <h1>Look Up a Prospect</h1>
            <p>
              Fill in the information below to locate a prospect's donation
              history.
            </p>
          </HeadingWrapper>
          <PrimarySearchFormStyles>
            <Form className="search-form" onSubmit={onSubmit}>
              <label className="search-form__label" htmlFor="search">
                Name, Zip Code
              </label>
              <Text className="search-form__input" field="search" id="search" />

              <button type="submit" className="search-form__button">
                <IconSearch />
                <span className="visuallyhidden">Submit</span>
              </button>
            </Form>
          </PrimarySearchFormStyles>

          <p>
            Or{' '}
            <button
              className="button--inline-text"
              onClick={toggleAdvancedFormDialog}
            >
              search with advanced criteria
            </button>.
          </p>
        </ContentWrapper>

        {showAdvancedForm && (
          <AdvancedSearchForm
            open={showAdvancedForm}
            close={toggleAdvancedFormDialog}
            onSubmit={onSubmit}
          />
        )}
      </Fragment>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/PrimarySearchForm/PrimarySearchForm.js